import { Maybe } from 'types/FMSGraphqlTypes'
import formatCurrency from 'utils/formatCurrency'
import { TCarrierDedicatedLaneRatePreference } from '../types'

interface IGetDedicatedLanesLabelsResult {
  preferenceLabel: 'Yes' | 'No'
  rpmLabel: Maybe<string>
}

export const getDedicatedLanesLabels = (
  dedicatedLaneRatePreference: Maybe<TCarrierDedicatedLaneRatePreference>
): IGetDedicatedLanesLabelsResult => {
  const { isInterestedInDedicatedLanes, minimumRatePerMile } = dedicatedLaneRatePreference || {}
  return {
    preferenceLabel: isInterestedInDedicatedLanes ? 'Yes' : 'No',
    rpmLabel: isInterestedInDedicatedLanes
      ? `min rate ${formatCurrency(minimumRatePerMile)}/mi`
      : null,
  }
}
